'use client'

import Link from 'next/link'
import { useTranslation } from '@/i18n/client'
import {
  AwardLegalShell,
  type LegalArticle,
} from '@/components/award/legal-shell'

const articles: LegalArticle[] = [
  {
    num: 'I', numDisplay: '01', title: 'Angaben gemäß § 5 DDG', titleI18nKey: 'legal.impressumTitles.t01',
    body: (
      <>
        <div className="award-contact-card">
          <div className="award-contact-label">Anschrift</div>
          <div className="award-contact-value">
            <strong>Stephan Eich Modellpilot.EU</strong>
            <br />
            Sedanstrasse 2
            <br />
            12167 Berlin
            <br />
            Deutschland
          </div>
        </div>
        <p style={{ marginTop: '1.4em' }}>
          <strong>Die FREE GLIDE LEAGUE ist ein Projekt des Einzelunternehmens{' '}
          Stephan Eich Modellpilot.EU.</strong>{' '}
          Plattform, Coaching-App und zugehörige Dienste werden im Rahmen dieses
          Einzelunternehmens in Gewinnerzielungsabsicht betrieben.
        </p>
      </>
    ),
  },
  {
    num: 'II', numDisplay: '02', title: 'Vertreten durch', titleI18nKey: 'legal.impressumTitles.t02',
    body: (
      <div className="award-contact-card">
        <div className="award-contact-label">Inhaber</div>
        <div className="award-contact-value"><strong>Stephan Eich</strong></div>
      </div>
    ),
  },
  {
    num: 'III', numDisplay: '03', title: 'Kontakt', titleI18nKey: 'legal.impressumTitles.t03',
    body: (
      <div className="award-laender-grid">
        <div className="award-contact-card">
          <div className="award-contact-label">Telefon</div>
          <div className="award-contact-value">
            <a href="tel:+493039885788">+49 30 39885788</a>
          </div>
        </div>
        <div className="award-contact-card">
          <div className="award-contact-label">E-Mail</div>
          <div className="award-contact-value">
            <a href="mailto:info@modellpilot.eu">info@modellpilot.eu</a>
          </div>
        </div>
      </div>
    ),
  },
  {
    num: 'IV', numDisplay: '04', title: 'Umsatzsteuer-ID', titleI18nKey: 'legal.impressumTitles.t04',
    body: (
      <div className="award-contact-card">
        <div className="award-contact-label">USt-ID nach § 27a UStG</div>
        <div className="award-contact-value"><strong>DE156312966</strong></div>
      </div>
    ),
  },
  {
    num: 'V', numDisplay: '05', title: 'Inhaltlich verantwortlich gemäß § 18 Abs. 2 MStV', titleI18nKey: 'legal.impressumTitles.t05',
    body: (
      <p>Stephan Eich, Anschrift siehe oben.</p>
    ),
  },
  {
    num: 'VI', numDisplay: '06', title: 'EU-Streitschlichtung', titleI18nKey: 'legal.impressumTitles.t06',
    body: (
      <>
        <p>
          Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS)
          bereit:{' '}
          <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer">
            ec.europa.eu/consumers/odr
          </a>.
        </p>
        <p>
          Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
          Verbraucherschlichtungsstelle teilzunehmen.
        </p>
      </>
    ),
  },
  {
    num: 'VII', numDisplay: '07', title: 'Haftung für Inhalte', titleI18nKey: 'legal.impressumTitles.t07',
    body: (
      <>
        <p>
          Als Diensteanbieter sind wir gemäß § 7 Abs. 1 DDG für eigene Inhalte auf diesen
          Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 DDG sind wir
          als Diensteanbieter jedoch nicht verpflichtet, übermittelte oder gespeicherte
          fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine
          rechtswidrige Tätigkeit hinweisen.
        </p>
        <p>
          Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach
          den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung
          ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung
          möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese
          Inhalte umgehend entfernen.
        </p>
      </>
    ),
  },
  {
    num: 'VIII', numDisplay: '08', title: 'Haftung für Links', titleI18nKey: 'legal.impressumTitles.t08',
    body: (
      <>
        <p>
          Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir
          keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine
          Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige
          Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden
          zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige
          Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar.
        </p>
        <p>
          Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne
          konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden
          von Rechtsverletzungen werden wir derartige Links umgehend entfernen.
        </p>
      </>
    ),
  },
  {
    num: 'IX', numDisplay: '09', title: 'Urheberrecht', titleI18nKey: 'legal.impressumTitles.t09',
    body: (
      <p>
        Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten
        unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung,
        Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes
        bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
        Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen
        Gebrauch gestattet.
      </p>
    ),
  },
  {
    num: 'X', numDisplay: '10', title: 'Hinweis zur Funktion der Plattform', titleI18nKey: 'legal.impressumTitles.t10',
    body: (
      <>
        <p>
          Diese Plattform ist ein technischer Analyse-, Dokumentations- und
          Auswertungsdienst für den Modellflugsport und Teil des Unternehmens Stephan Eich
          Modellpilot.EU. Sie stellt Werkzeuge für Upload, Analyse, Visualisierung,
          Regelprüfung, Klassifizierung und die Darstellung von Ranglisten und
          Wertungstabellen bereit. Zusätzlich wird eine zugehörige Coaching-App (Android) im
          kostenpflichtigen Jahresabonnement angeboten.
        </p>
        <p>
          Soweit nicht ausdrücklich schriftlich anders bekannt gemacht, ist der Betreiber
          Veranstalter der Plattform, der Wettbewerbsserie, der Regeln, der Auswertung und
          der Pokalvergabe, jedoch nicht Veranstalter des einzelnen dezentral durch den
          Piloten durchgeführten Fluges, nicht Fernpilot des eingesetzten Modells und nicht
          Betreiber des vom Nutzer eingesetzten Flugmodells.
        </p>
        <p>
          Die Verantwortung für die rechtmäßige, sichere und versicherte Durchführung eines
          konkreten Fluges liegt ausschließlich beim jeweiligen Piloten und gegebenenfalls
          beim örtlichen Betreiber, Verein, Platzhalter, Geländebetreiber oder sonstigen
          lokalen Ausrichter.
        </p>
      </>
    ),
  },
  {
    num: 'XI', numDisplay: '11', title: 'Einsatz von KI · Transparenz nach EU AI Act Art. 50', titleI18nKey: 'legal.impressumTitles.t11',
    body: (
      <>
        <p>
          <strong>Hausintern gehostete KI, keine externe API.</strong> Alle
          KI-gestützten Funktionen von FREE GLIDE LEAGUE (Chat-Assistenten Cirra und
          Freeglidy, KI-Fluganalyse, KI-Modellberatung, KI-Wetterbericht, automatisch
          erstellte Teilnahmebescheinigung) laufen ausschließlich auf hausinternen
          Servern von Modellpilot.EU (Domain free-glide-league.com), Rechenzentrum
          Deutschland, Ollama-Sprachmodelle on-premise. Es wird für Nutzer-Inhalte
          KEINE externe KI-API (OpenAI, Anthropic, Google, Mistral o.ä.) verwendet.
          Nutzer-Eingaben, IGC-Daten und Chat-Verläufe verlassen die FGL-Infrastruktur
          nicht.
        </p>
        <p>
          <strong>Kennzeichnung von KI-Inhalten (EU AI Act Art. 50).</strong>
          Vollständig KI-generierte Ausgaben werden mit dem offiziellen Piktogramm
          „KI-generiert" der Europäischen Kommission gekennzeichnet. Redaktionell durch
          den Betreiber überarbeitete Inhalte mit KI-Unterstützung (insbesondere
          News-Beiträge) tragen das Piktogramm „KI-bearbeitet". Chat-Assistenten
          weisen zu Beginn jeder Interaktion auf ihre KI-Eigenschaft hin.
        </p>
        <p>
          <strong>Technische Umsetzung.</strong> Die Software-Entwicklung dieser
          Plattform wurde teilweise mit KI-Programmierassistenz (Anthropic Claude
          Code) durchgeführt. Jede Code-Änderung wurde vom Betreiber Stephan Eich
          redaktionell geprüft, freigegeben und deployt (menschliche Editorial-Kontrolle
          gemäß Erwägungsgrund 134 der Verordnung (EU) 2024/1689). Verantwortung für
          Inhalte, Betrieb und Verfügbarkeit trägt der Betreiber.
        </p>
      </>
    ),
  },
]

export default function ImpressumPage() {
  const { t } = useTranslation()
  return (
    <AwardLegalShell
      eyebrow={t('legal.impressum.eyebrow')}
      meta={t('legal.impressum.metaLocation')}
      title={t('legal.impressum.title')}
      gradWord={t('legal.impressum.gradWord')}
      lead={t('legal.impressum.lead')}
      chips={[
        { label: t('legal.impressum.chip1') },
        { label: t('legal.impressum.chip2') },
        { label: t('legal.impressum.chip3') },
      ]}
      tocEyebrow={t('legal.impressum.tocEyebrow')}
      tocTitle={t('legal.impressum.tocTitle')}
      articles={articles}
      closingEyebrow={t('legal.impressum.closingEyebrow')}
      closingTitle={
        <>
          {t('legal.impressum.closingPrefix')}{' '}
          <Link href="/nutzungsbedingungen" className="award-link">{t('legal.impressum.closingNutzungsbedingungen')}</Link>{' '}
          {t('legal.impressum.closingAnd')}{' '}
          <Link href="/datenschutz" className="award-link">{t('legal.impressum.closingDatenschutz')}</Link>.
        </>
      }
      primaryCta={{ href: '/datenschutz', label: t('legal.impressum.primaryCta') }}
      secondaryCta={{ href: '/', label: t('legal.impressum.secondaryCta') }}
      showGlider={true}
    />
  )
}
